export default "__VITE_ASSET__Ddts_RLg__"